import { render, staticRenderFns } from "./LoanInsight.vue?vue&type=template&id=1ad3671f&scoped=true"
import script from "./LoanInsight.vue?vue&type=script&lang=js"
export * from "./LoanInsight.vue?vue&type=script&lang=js"
import style0 from "./LoanInsight.vue?vue&type=style&index=0&id=1ad3671f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad3671f",
  null
  
)

export default component.exports